import CharCount from '../../../components/charCount/CharCount';
import styles from '../reviewBookingCamp.module.css';

/*
 * Only the lead guest is asked for — they check in for everyone
 * (same fields as the first traveller on the trip / activity review).
 */
export default function LeadGuestForm({ guest, onChange, specialRequests, onRequestsChange }) {
    const set = (field) => (e) => onChange({ ...guest, [field]: e.target.value });

    const setPhone = (e) => {
        const value = e.target.value.replace(/\D/g, '').replace(/^0+/, '').slice(0, 10);
        onChange({ ...guest, phoneNumber: value });
    };

    return (
        <div className='reviewBoInfoUserDiv'>
            <p className={styles.formNote}>Lead guest — this person checks in for everyone in the booking.</p>
            <div className='reviewBoInfoNameAge'>
                <div className='reviewBoInfoName'>
                    <label className='reviewBoInfoLabel' htmlFor='stayGuestName'>
                        Full Name
                    </label>
                    <input
                        id='stayGuestName'
                        value={guest.name}
                        onChange={set('name')}
                        type='text'
                        autoComplete='name'
                        placeholder='Name as on ID proof'
                        className='reviewBoInfoInput'
                    />
                    <CharCount string={guest.name || ''} min={3} limit={50} />
                </div>
                <div className='reviewBoInfoName'>
                    <label className='reviewBoInfoLabel' htmlFor='stayGuestEmail'>
                        Email
                    </label>
                    <input
                        id='stayGuestEmail'
                        value={guest.emailId}
                        onChange={set('emailId')}
                        type='email'
                        autoComplete='email'
                        placeholder='Booking details are sent here'
                        className='reviewBoInfoInput'
                    />
                </div>
            </div>
            <div className='reviewBoInfoNameAge'>
                <div className='reviewBoInfoName'>
                    <label className='reviewBoInfoLabel' htmlFor='stayGuestPhone'>
                        Phone Number (WhatsApp)
                    </label>
                    <input
                        id='stayGuestPhone'
                        value={guest.phoneNumber}
                        onChange={setPhone}
                        type='tel'
                        inputMode='numeric'
                        autoComplete='tel-national'
                        maxLength={10}
                        placeholder='Mobile Number'
                        className='reviewBoInfoInput'
                    />
                </div>
            </div>

            <div className={styles.requests}>
                <label className='reviewBoInfoLabel' htmlFor='stayRequests'>
                    Special requests <span className={styles.optional}>(optional)</span>
                </label>
                <textarea
                    id='stayRequests'
                    value={specialRequests}
                    onChange={(e) => onRequestsChange(e.target.value.slice(0, 500))}
                    rows={3}
                    placeholder='Early check-in, dietary needs, celebration… (the property will try its best)'
                    className={`reviewBoInfoInput ${styles.textarea}`}
                />
                <CharCount string={specialRequests} min={0} limit={500} />
            </div>
        </div>
    );
}
